import $ from 'jquery';
/* eslint-disable no-unused-vars */
document.addEventListener("DOMContentLoaded", function () {
	const lazyIframes = document.querySelectorAll(".descr-item iframe, .map-side iframe");

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const iframe = entry.target;
				iframe.src = iframe.dataset.src;
				observer.unobserve(iframe);
			}
		});
	});

	lazyIframes.forEach(iframe => {
		observer.observe(iframe);
	});
});

$(document).ready(function(){
	document.querySelectorAll('a[href^="#"]:not(.b-page-menu-nav__item-link, .b-page-menu-nav__subitem a)').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			const targetId = this.getAttribute('href');
			if (targetId === '#') return;

			const targetElement = document.querySelector(targetId);
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth'
				});
			}
		});
	});

	// custom subscribe form on ajax
	$(document).on('click', '.subscribe-form .submit-btn', function(e){
		const thisSubForm = $(this).closest('.subscribe-form');
		const checkbox = thisSubForm.find('input[name="check"]');

		if (checkbox.is(':checked')) {
			$.getJSON('/_ajax/subscribe.php', {
				email:thisSubForm.find('input[name="EMAIL"]').val(),
				id:thisSubForm.find('input[name="SUB_ID"]').val()
			}, function(data){
				if (data.status=='ok'){
					thisSubForm.find('.subscribe-form__success').addClass('show');
				} else {
					alert(data.msg);
				}
			});
		} else {
			alert('Не заполнено поле Согласие на обработку персональных данных');
		}

		e.preventDefault();
	});

	$(document).on('click', '.workresult-adult', function (e) {
		e.preventDefault();
		let link = $(this).parent().find('.image-link');
		$(link).removeClass('adult')
		$(this).remove();
	})

	$(document).on('submit', '.pdf-form', function (e) {
		e.preventDefault();
		//let _self = this;

		const action = $(this).attr('action'); // Получаем URL из атрибута action
		const formData = new FormData(this);

		// Отправка данных как FormData
		fetch(action, {
			method: 'POST',
			body: formData,
			headers: {
				'X-CSRFToken': getCookie('csrftoken') // Если используете Django
			}
		})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(data => {
				generateAndSavePDF();
			})
			.catch(error => {
				console.error('Error:', error);
				alert('Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.');
			});
	});

	$(document).on('submit', '.another-form', function (e) {
		e.preventDefault();
		let _self = this;

		const action = $(this).attr('action'); // Получаем URL из атрибута action
		const formData = new FormData(this);

		// Отправка данных как FormData
		fetch(action, {
			method: 'POST',
			body: formData,
			headers: {
				'X-CSRFToken': getCookie('csrftoken') // Если используете Django
			}
		})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(data => {
				//console.log(2323);
			})
			.catch(error => {
				console.error('Error:', error);
				alert('Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.');
			});
	});

	$(document).on('click', '.list-group .submit-btn, .list-group .reset-link', function (e) {
		$(this).parents('.list-group').find('.choose-list').hide();
		$(this).parents('.list-group').find('.js-list-link').removeClass('active');
	});

	$(document).on('click', '.app-link .link-item', function () {
		$('.links-list').toggleClass('hidden');
	});
});

function validateRequiredFields(form) {
	let isValid = true;

	// Сбрасываем предыдущие ошибки
	$(form).find('.input-group').removeClass('error');
	$(form).find('.error-message').remove();

	// Проверяем только required поля
	$(form).find('[required]').each(function() {
		const $field = $(this);
		const $group = $field.closest('.input-group');
		const fieldType = $field.attr('type');
		const fieldName = $field.attr('name');
		const fieldValue = $field.val().trim();

		// Проверка пустых полей (input, textarea)
		if (fieldValue === '' && !$field.is('[type="radio"], [type="checkbox"]')) {
			showError($group, 'Обязательное поле');
			isValid = false;
		}

		// Проверка radio-кнопок (хотя бы одна выбрана)
		if (fieldType === 'radio' && !$(form).find(`[name="${fieldName}"]:checked`).length) {
			showError($group, 'Выберите вариант');
			isValid = false;
		}

		// Проверка checkbox (должен быть отмечен)
		if (fieldType === 'checkbox' && !$field.is(':checked')) {
			showError($group, 'Необходимо согласие');
			isValid = false;
		}

		// Доп. проверка email (если поле не пустое)
		if (fieldType === 'email' && fieldValue && !isValidEmail(fieldValue)) {
			showError($group, 'Некорректный email');
			isValid = false;
		}

		// Доп. проверка телефона (если поле не пустое)
		if ($field.hasClass('js-phone-input') && fieldValue && !isValidPhone(fieldValue)) {
			showError($group, 'Некорректный телефон');
			isValid = false;
		}
	});

	return isValid;
}

// Показать ошибку
function showError($group, message) {
	$group.addClass('error');
	$group.append('<div class="error-message">'+message+'</div>');
}

// Валидация email
function isValidEmail(email) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// Валидация телефона (минимум 11 цифр)
function isValidPhone(phone) {
	return phone.replace(/\D/g, '').length >= 11;
}

async function generateAndSavePDF() {
	const element = document.documentElement;
	//const element = document.getElementsByClassName('main-wrapper');

	const pages = Array.from(document.querySelectorAll('div[aria-label^="pdf-page-"]'));

	const opt = {
		margin: 1,
		filename: 'document.pdf',
		html2canvas: {
			scale: 1, // Уменьшите если есть проблемы
			scrollY: 0,
			windowWidth: element.scrollWidth + 50, // Запас
			useCORS: true,
			allowTaint: true,
			logging: true,
		},
		jsPDF: {
			unit: 'mm',
			format: 'a4',
			orientation: 'portrait',
			hotfixes: ["px_scaling"] // Исправление масштабирования
		}
	};

	try {
		// eslint-disable-next-line no-undef
		await html2pdf().set(opt).from(element).toCanvas();
		await new Promise(resolve => setTimeout(resolve, 500));
		//const pdf = await html2pdf().from(pages[0]).set(opt).outputPdf('blob');

		// 4. Финальная генерация
		// eslint-disable-next-line no-undef
		const pdf = await html2pdf()
			.set(opt)
			.from(element)
			.toPdf()
			.get('pdf')
			.then(pdf => {
				const pages = pdf.internal.getNumberOfPages();
				//console.log(`Сгенерировано страниц: ${pages}`);
				return pdf.output('blob');
			});

		let url = window.location.pathname;
		// 1. Удаляем слэши в начале и конце
		const trimmedUrl = url.replace(/^\/|\/$/g, '');

		// 2. Разбиваем на части по слэшам
		const parts = trimmedUrl.split('/');

		// 3. Извлекаем нужные сегменты
		const dynamicPart = parts[3];
		const childPart = parts[2];
		const clinicPart = parts[1];

		// 4. Собираем в нужном порядке
		const fileName = dynamicPart+'_'+childPart+'_'+clinicPart+'.pdf';
		await uploadPDF(pdf, fileName);
		$.magnificPopup.open({
			items: {
				src: '#send_modal'
			},
			type: 'inline'
		});
		$('.pdf-form')[0].reset();
	} catch (error) {
		console.error('Ошибка:', error);
	}
}

async function uploadPDF(pdfBlob, fileName) {
	const formData = new FormData();
	formData.append('pdf_file', pdfBlob, fileName);

	const response = await fetch('/api/forms/save_pdf/', {
		method: 'POST',
		body: formData
	});

	if (!response.ok) {
		throw new Error('Ошибка при сохранении PDF');
	}

	return response.json();
}

function getCookie(name) {
	let cookieValue = null;
	if (document.cookie && document.cookie !== '') {
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			if (cookie.substring(0, name.length + 1) === (name + '=')) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}

function setCookie(name, value, options = {}) {
	options = {
		path: '/',
	};
	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}
	let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
	for (let optionKey in options) {
		updatedCookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			updatedCookie += "=" + optionValue;
		}
	}
	document.cookie = updatedCookie;
};

/* eslint-enable no-unused-vars */